export const nameApp = 'Học Liệu';
